/* T039/T040 — SDK Alma natif : échéance 3x réelle, jamais un prix / 3 présumé.
   Classe autonome, remontée par la Section Rendering API et l'éditeur. */
(function () {
  'use strict';
  if (customElements.get('jaiio-alma-line')) return;

  var sdkPromise;
  var sequence = 0;
  function loadSdk() {
    if (window.Alma && window.Alma.Widgets) return Promise.resolve(window.Alma);
    if (sdkPromise) return sdkPromise;
    sdkPromise = new Promise(function (resolve, reject) {
      var existing = document.querySelector('script[src*="@alma/widgets"][src*="widgets.umd.js"]');
      var script = existing || document.createElement('script');
      var timeout = setTimeout(function () { reject(new Error('Alma SDK timeout')); }, 15000);
      function ready() {
        clearTimeout(timeout);
        if (window.Alma && window.Alma.Widgets) resolve(window.Alma);
        else reject(new Error('Alma SDK unavailable'));
      }
      script.addEventListener('load', ready, { once: true });
      script.addEventListener('error', function () { clearTimeout(timeout); reject(new Error('Alma SDK load failed')); }, { once: true });
      if (!document.querySelector('link[href*="@alma/widgets"][href*="widgets.min.css"]')) {
        var css = document.createElement('link');
        css.rel = 'stylesheet';
        css.href = 'https://cdn.jsdelivr.net/npm/@alma/widgets@4.x.x/dist/widgets.min.css';
        document.head.appendChild(css);
      }
      if (!existing) {
        script.src = 'https://cdn.jsdelivr.net/npm/@alma/widgets@4.x.x/dist/widgets.umd.js';
        script.async = true;
        document.head.appendChild(script);
      }
    });
    return sdkPromise;
  }

  class AlmaLine extends HTMLElement {
    connectedCallback() {
      if (this.started || this.dataset.currency !== 'EUR' || !(Number(this.dataset.amount) > 0)) return;
      this.started = true;
      this.trigger = this.querySelector('button');
      this.widget = this.querySelector('.j-alma-line__widget');
      this.widget.id = 'jaiio-alma-' + (++sequence);
      this.onClick = () => {
        if (!this.widgets) return;
        // Le dialogue Alma vit dans le body : suspendre le piège du tiroir
        // pendant son ouverture, puis lui rendre le focus à la fermeture.
        this.drawer = this.closest('cart-drawer[open]');
        if (this.drawer && this.drawer.focusTrap) this.drawer.focusTrap.pause();
        if (!this.modal) {
          this.modalContainer = document.createElement('div');
          this.modalContainer.id = this.widget.id + '-modal';
          document.body.appendChild(this.modalContainer);
          this.modal = this.widgets.add(window.Alma.Widgets.Modal, Object.assign({}, this.options, {
            container: '#' + this.modalContainer.id,
            onClose: () => this.restoreFocus()
          }));
        }
        this.modal.open();
      };
      this.trigger.addEventListener('click', this.onClick);
      this.observer = new MutationObserver(() => this.sync());
      this.observer.observe(this.widget, { childList: true, subtree: true, attributes: true, characterData: true });
      loadSdk().then(Alma => {
        if (!this.isConnected) return;
        var merchant = window.ALMA_MERCHANT_ID || this.dataset.merchant;
        if (!merchant) return;
        var min = Number(this.dataset.min);
        var max = Number(this.dataset.max);
        if (window.ALMA_FEE_PLANS) {
          var feePlan = JSON.parse(window.ALMA_FEE_PLANS).general_3_0_0;
          if (!feePlan || ![true, 'True'].includes(feePlan.is_enabled)) return;
          min = Number(feePlan.min_amount);
          max = Number(feePlan.max_amount);
        }
        if (!(min > 0 && max >= min)) return;
        this.widgets = Alma.Widgets.initialize(merchant, Alma.ApiMode.LIVE);
        this.options = {
          container: '#' + this.widget.id,
          purchaseAmount: Number(this.dataset.amount),
          locale: this.dataset.locale,
          plans: [{ installmentsCount: 3, minAmount: min, maxAmount: max }],
          suggestedPaymentPlan: 3,
          transitionDelay: -1,
          hideIfNotEligible: true,
          monochrome: true,
          onModalClose: () => this.restoreFocus()
        };
        this.widgets.add(Alma.Widgets.PaymentPlans, this.options);
      }).catch(error => {
        this.trigger.hidden = true;
        console.warn('[jaiio-alma] ' + error.message);
      });
    }

    sync() {
      var three = Array.from(this.widget.querySelectorAll('[role="option"]')).find(button => /^3x$/i.test(button.textContent.trim()));
      var info = this.widget.querySelector('.alma-payment-plans-payment-info');
      var eligible = three && three.getAttribute('aria-disabled') === 'false';
      // Le modal peut choisir un autre plan ; garder le résumé 3x déjà reçu.
      if (eligible && three.getAttribute('aria-selected') !== 'true') return;
      var text = info && info.textContent.trim().replace(/\s+/g, ' ');
      this.trigger.hidden = !(eligible && text);
      if (this.trigger.hidden) return;
      var summary = text.replace(/\s*\([^]*$/, '');
      if (/^3\s*x\s/i.test(summary)) summary = summary.replace(/^3\s*x\s*/i, '3 × ');
      else {
        // Alma répartit les centimes : première échéance puis deux identiques.
        // « dès » annonce ce montant réel ; le détail conserve l'échéancier exact.
        var amounts = summary.match(/€\s*\d[\d\s.,]*|\d[\d\s.,]*\s*€/g);
        if (!amounts || amounts.length !== 2) { this.trigger.hidden = true; return; }
        summary = '3 × ' + this.dataset.from + ' ' + amounts[1].trim();
      }
      this.querySelector('[data-alma-amount]').textContent = summary;
      this.trigger.setAttribute('aria-label', text + ' — Alma');
    }

    restoreFocus() {
      if (this.drawer && this.drawer.open && this.drawer.focusTrap) this.drawer.focusTrap.unpause();
      this.drawer = null;
      if (this.isConnected) this.trigger.focus();
    }

    disconnectedCallback() {
      if (this.observer) this.observer.disconnect();
      if (this.trigger) this.trigger.removeEventListener('click', this.onClick);
      if (this.modal) this.modal.close();
      if (this.modalContainer) this.modalContainer.remove();
      this.modal = null;
      this.started = false;
    }
  }
  customElements.define('jaiio-alma-line', AlmaLine);
})();
